import { create, useModal } from '@ebay/nice-modal-react';
import { useMemo } from 'react';

import { EnterReferralCodeActionSheetController } from './enter-referral-code-action-sheet.controller';

const EnterReferralCodeActionSheetModal = create(EnterReferralCodeActionSheetController);

export const useEnterReferralCodeActionSheet = () => {
  const { show } = useModal(EnterReferralCodeActionSheetModal);
  return useMemo(() => ({ open: show }), [show]);
};
